// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
// Generated on Thursday, November 21, 2024
// @oneaudi/unified-web-common: 1.0.3
export const SYS_FONT_SIZES_RELATIVE_75 = '12px';
export const SYS_FONT_SIZES_RELATIVE_100 = '16px';
export const SYS_FONT_SIZES_RELATIVE_125 = '20px';
export const SYS_FONT_SIZES_RELATIVE_150 = '24px';
export const SYS_FONT_SIZES_RELATIVE_175 = '28px';
export const SYS_FONT_SIZES_RELATIVE_200 = '32px';
export const SYS_FONT_SIZES_RELATIVE_225 = '36px';
export const SYS_FONT_SIZES_RELATIVE_250 = '40px';
export const SYS_FONT_SIZES_RELATIVE_275 = '44px';
export const SYS_FONT_SIZES_RELATIVE_300 = '48px';
export const SYS_FONT_SIZES_RELATIVE_325 = '52px';
export const SYS_FONT_SIZES_RELATIVE_375 = '60px';
export const SYS_FONT_SIZES_RELATIVE_450 = '72px';
export const SYS_FONT_SIZES_RELATIVE_525 = '84px';
export const SYS_FONT_SIZES_RELATIVE_62_5 = '10px';
export const SYS_FONT_SIZES_RELATIVE_112_5 = '18px';
//# sourceMappingURL=font-sizes.generated.js.map